import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../utility/apiInstance";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import {
  Autocomplete,
  TextField,
  Chip,
  Checkbox,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridSlots,
} from "@mui/x-data-grid";
import toast from "react-hot-toast";
import { preventAddingDuplocateRow } from "../../utility/constant";
import clsx from "clsx";
import SearchInput from "../../common/SearchInput";
import { CustomLoadingOverlay, CustomNoRowsOverlay } from "../../common/Datagridoverlays";
import { FOOTER_HEIGHT, HEADER_HEIGHT, MAX_GRID_HEIGHT, MIN_GRID_HEIGHT, ROW_ESTIMATE } from "../../components/Contants/constantValue";

function randomId() {
  return Math.random().toString(36).substr(2, 9);
}

const id = randomId();

// EditToolbar now returns null — Add Record button moved outside DataGrid
function EditToolbar() {
  return null;
}



export default function OceanCommunicationContactDataTemplate() {
 
  const is1366 = useMediaQuery("(max-width:1366px)");
  const [rows, setRows] = React.useState([]);
  const [rowdata, setRowdata] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [contactdata, setContactdata] = React.useState({
    whatsApp: [],
    email: [],
  });
  const [currentPage, setCurrentPage] = React.useState(0);
  const [milestonedata, setMilestonedata] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
  const [whatsappGroup, setWhatsappGroup] = React.useState([]);
  const [isAddDisabled, setIsAddDisabled] = React.useState(false);
  const [flags, setFlags] = React.useState([]);
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [emailPreviewData, setEmailPreviewData] = React.useState<{
    subject: string;
    html: string;
  } | null>(null);
  const [whatsappPreviewData, setwhatsappPreviewData] = React.useState<string | null>(null);

  // ── Search state ──────────────────────────────────────────────
  const [searchQuery, setSearchQuery] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");

  // Debounce search input
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  // Re-fetch on debounced search change
  React.useEffect(() => {
    getTemplatedata(debouncedSearch);
  }, [debouncedSearch]);
  // ─────────────────────────────────────────────────────────────

  const getContactList = async () => {
    try {
      const [emailResp, whatsappResp] = await Promise.all([
        axiosInstance.get("/api/v1/contact?channel=email"),
        axiosInstance.get("/api/v1/contact?channel=whatsapp"),
      ]);
      setContactdata((prev: any) => ({
        ...prev,
        whatsApp: whatsappResp?.data?.data,
        email: emailResp?.data?.data,
      }));
    } catch (err: any) { }
  };

  const getTemplatedata = async (search: string = "") => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/api/v1/ocean-communication-templete?search=${encodeURIComponent(search)}`
      );
      setRows(response.data.data);
    } catch (error) {
      setRows([])
    } finally {
      setLoading(false);
    }
  };

  const getmilestone = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/ocean/ocean-milestone");
      setMilestonedata(response?.data?.data);
    } catch (error) { }
  };

  async function getFlagsList() {
    try {
      const { data } = await axiosInstance.get("/api/v1/flags");
      let finaldata = data.data
        .filter((flag: any) => flag.status == "Active")
        .map((flag: any) => {
          let flagId = flag.id;
          delete flag.id;
          return { ...flag, _id: flagId };
        });
      setFlags(finaldata);
    } catch (error) {
      setFlags([]);
    }
  }

  const getWhatsappGroup = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/whatsapp-group");
      setWhatsappGroup(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    getTemplatedata("");
    getContactList();
    getmilestone();
    getFlagsList();
    getWhatsappGroup();
  }, []);

  // ── Add Record handler (moved out of toolbar) ─────────────────
  const handleAddClick = () => {
    const newId = Math.random();
    setRows((oldRows: any) => {
      if (!preventAddingDuplocateRow(oldRows)) {
        toast.error("You can only submit one record at a time!");
        return oldRows;
      }
      setIsAddDisabled(true);
      setRowModesModel((oldModel) => ({
        ...oldModel,
        [newId]: { mode: GridRowModes.Edit, fieldToFocus: "templatename" },
      }));
      return [
        {
          id: newId,
          templatename: "",
          waContacts: [],
          waMilestones: [],
          emailContacts: [],
          emailMilestones: [],
          whatsappGroups: [],
          whatsappGroupMilestones: [],
          isActive: true,
          isNew: true,
        },
        ...oldRows,
      ];
    });
  };
  // ─────────────────────────────────────────────────────────────

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId, row: any) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    setIsAddDisabled(true);
  };

  const handleSaveClick = (id: GridRowId) => async () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    setIsAddDisabled(false);
  };

  const handleDeleteClick = (id: GridRowId, row: any) => async () => {
    const url = `/api/v1/ocean-communication-templete/${id}`;
    try {
      const response = await axiosInstance.delete(url);
      getTemplatedata("");
      if (response.status === 200) {
        toast.success("Contact deleted successfully.");
      }
    } catch (error: any) {
      toast.error("An error occurred while updating contact status.");
    }
  };

  const handleCancelClick = (id: GridRowId) => async () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
    const editedRow: any = rows.find((row: any) => row.id === id);
    if (editedRow?.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
    setIsAddDisabled(false);
  };

  const handlePreviewClick = async (row: any) => {
    try {
      let payload = {
        emailMilestones: row.emailMilestones,
        waMilestones: row?.waMilestones,
        whatsappGroupMilestones: row?.whatsappGroupMilestones,
      };
      const { data } = await axiosInstance.post(
        "/api/v1/ocean-communication-templete/preview",
        payload
      );
      setEmailPreviewData({
        subject: data?.data?.EmailhtmlTemplete.subject || "",
        html: data?.data?.EmailhtmlTemplete?.html || "",
      });
      setwhatsappPreviewData(data?.data?.whatsappHtmlTemplete || "");
      setPreviewOpen(true);
    } catch (error) {
      console.error("Preview API error:", error);
    }
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow: any = { ...newRow, isNew: false };
    setRowdata(updatedRow);

    if (!updatedRow.templatename) {
      toast.error("Template Name is required");
      setIsAddDisabled(true);
      return;
    } else if (!updatedRow.waMilestones || !updatedRow.emailMilestones || !updatedRow.flags) {
      toast.error("Contacts and Milestones are required");
      setIsAddDisabled(true);
      return;
    }

    if (updatedRow.id < 1) {
      updatedRow.id = id;

      if (!updatedRow.templatename) {
        toast.error("Template Name is required");
        setIsAddDisabled(true);
        return;
      }
      if (updatedRow?.templateName && !updatedRow?.waMilestones?.length) {
        toast.error("Atleast one mile-stone is required");
        setIsAddDisabled(true);
        return;
      }
      if (updatedRow?.templateName && !updatedRow?.emailMilestones?.length) {
        toast.error("Atleast one Mile-stone is required");
        setIsAddDisabled(true);
        return;
      }

      const formData = {
        templateName: updatedRow.templatename,
        waMilestones: updatedRow.waMilestones.map((milestone: any) => milestone?._id),
        emailMilestones: updatedRow.emailMilestones.map((milestone: any) => milestone?._id),
        flagIds: updatedRow?.flags?.map((flag: any) => flag?._id) || [],
      };

      try {
        let response = await axiosInstance.post(
          "/api/v1/ocean-communication-templete",
          formData
        );
        if (response.data.statusCode === 201) {
          toast.success(response.data.message);
          getTemplatedata("");
          setRows((prevRows: any) =>
            prevRows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
          );
          return updatedRow;
        }
      } catch (err: any) {
        const errors = err?.response?.data?.error;
        if (Array.isArray(errors)) {
          errors.forEach((errorObj) => {
            const { field, message } = errorObj;
            toast.error(`${field}: ${message}`);
          });
        } else if (typeof errors === "object") {
          Object.keys(errors).forEach((field) => {
            toast.error(`${field}: ${errors[field]}`);
          });
        } else if (typeof errors === "string") {
          toast.error(errors);
        }
      }
    } else {
      if (!updatedRow.templatename) {
        toast.error("Template Name is required");
        setIsAddDisabled(true);
        return;
      }
      if (updatedRow?.templateName && !updatedRow?.waMilestones?.length) {
        toast.error("Atleast one mile-stone is required ");
        setIsAddDisabled(true);
        return;
      }
      if (updatedRow?.templateName && !updatedRow?.emailMilestones?.length) {
        toast.error("Atleast one Mile-stone is required");
        setIsAddDisabled(true);
        return;
      } else {
        const formData = {
          templateName: updatedRow?.templatename,
          waMilestones: updatedRow?.waMilestones?.map((milestone: any) => milestone?._id),
          emailMilestones: updatedRow?.emailMilestones?.map((milestone: any) => milestone?._id),
          flagIds: updatedRow?.flags?.map((flag: any) => flag?._id) || [],
        };

        const url = `/api/v1/ocean-communication-templete/${updatedRow.id}`;

        try {
          const response = await axiosInstance.patch(url, formData);
          getTemplatedata("");

          const errorData = response.data?.error;
          if (typeof errorData === "object" && !Array.isArray(errorData)) {
            Object.keys(errorData).forEach((field) => {
              const message = errorData[field];
              toast.error(`${field}: ${message}`);
            });
          } else {
            setRows((prevRows: any) =>
              prevRows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
            );
            toast.success("Ocean template updated successfully");
            return updatedRow;
          }
        } catch (err: any) {
          if (Array.isArray(err.response?.data?.error)) {
            err.response.data.error.forEach((error: any) => {
              toast.error(`${error.field}: ${error.message}`);
            });
          } else {
            toast.error(
              err.response?.data?.error ||
              "An error occurred while updating the customer."
            );
          }
        }
      }
    }
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationChange = (paginationModel: any) => {
    setCurrentPage(paginationModel.page);
  };

  const gridHeight = Math.min(
    MAX_GRID_HEIGHT,
    Math.max(
      MIN_GRID_HEIGHT,
      HEADER_HEIGHT + FOOTER_HEIGHT + Math.max(rows.length, 1) * ROW_ESTIMATE
    )
  );

  const columns: GridColDef[] = [
    {
      field: "s_no",
      headerName: "S.No.",
      // width: isMobile ? 50 : 70,
      width: is1366 ? 60 : 110,
      sortable: true,
      filterable: false,
      editable: false,
      disableColumnMenu: true,
    },

    {
      field: "templatename",
      headerName: "Template Name",
      width: is1366 ? 150 : 200,
      sortable: true,
      filterable: true,
      editable: true,

      renderEditCell: (params) => (
        <TextField
          value={params.value || ""}
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              fontSize: "14px",
              backgroundColor: "#fff",

              "& fieldset": {
                borderColor: "#ddd",
              },

              "&:hover fieldset": {
                borderColor: "#ffb310",
              },

              "&.Mui-focused fieldset": {
                borderColor: "#ffb310",
                borderWidth: "2px",
              },
            },

            "& .MuiInputBase-input": {
              padding: "0",
            },
          }}
        />
      ),
    },

    {
      field: "waMilestones",
      headerName: "Whatsapp Milestone",
      sortable: true,
      filterable: false,
      editable: true,
      // width: isMobile ? 200 : 400,
      width: is1366 ? 300 : 450,
      renderCell: (params) => (
        <p>
          {params.row?.waMilestones
            ?.map((milestone: any) => milestone?.label)
            .filter(Boolean)
            .join(",")}
        </p>
      ),
      renderEditCell: (params) => (
        <Autocomplete
          multiple
          options={milestonedata || []}
          getOptionLabel={(option: any) => option.milestone}
          value={milestonedata.filter((item: any) =>
            params.row.waMilestones
              ?.map((milestone: any) => milestone?.milestone)
              ?.includes(item.milestone)
          )}
          onChange={(event, newValue) => {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue });
          }}
          disableCloseOnSelect
          fullWidth
          renderOption={(props, option: any, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => (
              <React.Fragment key={option.id || index}>
                <Chip
                  variant="outlined"
                  label={option.label}
                  {...getTagProps({ index })}
                  sx={{ margin: "4px 2px" }}
                />
              </React.Fragment>
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  whiteSpace: "normal",
                  overflowY: "auto",
                  maxHeight: 200,
                },
              }}
            />
          )}
        />
      ),
    },
    {
      field: "emailMilestones",
      headerName: "Email Milestone",
      // width: isMobile ? 200 : 400,
      width: is1366 ? 300 : 600,
      sortable: true,
      filterable: false,
      editable: true,
      renderCell: (params) => (
        <p>
          {params.row?.emailMilestones
            ?.map((milestone: any) => milestone?.label)
            .filter(Boolean)
            .join(", ")}
        </p>
      ),
      renderEditCell: (params) => (
        <Autocomplete
          multiple
          options={milestonedata || []}
          getOptionLabel={(option: any) => option.milestone}
          value={milestonedata.filter((item: any) =>
            params.row.emailMilestones
              ?.map((milestone: any) => milestone?.milestone)
              ?.includes(item.milestone)
          )}
          onChange={(event, newValue) => {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue });
          }}
          disableCloseOnSelect
          renderOption={(props, option: any, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.label}
            </li>
          )}
          fullWidth
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => (
              <React.Fragment key={option.id || index}>
                <Chip
                  variant="outlined"
                  label={option.label}
                  {...getTagProps({ index })}
                  sx={{ margin: "4px 2px" }}
                />
              </React.Fragment>
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  whiteSpace: "normal",
                  overflowY: "auto",
                  maxHeight: 200,
                },
              }}
            />
          )}
        />
      ),
    },
    {
      field: "flags",
      headerName: "Flag",
      sortable: true,
      filterable: false,
      editable: true,
      // width: isMobile ? 190 : 220,
      width: is1366 ? 220 : 200,
      flex: 0,
      renderCell: (params) => (
        <p>{params.row?.flags?.map((f: any) => f?.name).join(", ")}</p>
      ),
      renderEditCell: (params) => (
        <Autocomplete
          multiple
          options={flags || []}
          getOptionLabel={(option: any) => option.name}
          value={flags.filter((item: any) =>
            params.row.flags?.map((f: any) => f?.name).includes(item.name)
          )}
          onChange={(event, newValue) => {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue });
          }}
          disableCloseOnSelect
          fullWidth
          renderOption={(props, option: any, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.name}
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option: any, index) => (
              <Chip
                variant="outlined"
                label={option.name}
                {...getTagProps({ index })}
                sx={{ margin: "4px 2px" }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                style: {
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  whiteSpace: "normal",
                  overflowY: "auto",
                  maxHeight: 200,
                },
              }}
            />
          )}
        />
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      // ...(isBigScreen ? { flex: 1, width: 200 } : { flex: 0 }),
      width: is1366 ? 180 : 200,
      cellClassName: "actions",
      getActions: ({ id, row }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              key={`save-${id}`}
              icon={<SaveIcon />}
              label="Save"
              sx={{ color: "primary.main" }}
              onClick={handleSaveClick(id)}
              className="iconMilestone_save"
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              key={`cancel-${id}`}
              label="Cancel"
              className="iconMilestone_close"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          row?.id < 1 ? (
            <></>
          ) : (
            <GridActionsCellItem
              icon={<EditIcon />}
              key={`edit-${id}`}
              label="Edit"
              className="iconMilestone_edit"
              onClick={handleEditClick(id, row)}
              color="inherit"
            />
          ),
          row?.id < 1 ? (
            <></>
          ) : (
            <GridActionsCellItem
              key={`delete-${id}`}
              icon={<DeleteIcon />}
              sx={{ ":hover": { color: "red" } }}
              label="Delete"
              onClick={handleDeleteClick(id, row)}
              color="inherit"
              className="iconMilestone_close"
            />
          ),
          row?.id < 1 ? (
            <></>
          ) : (
            <GridActionsCellItem
              key={`preview-${id}`}
              icon={<VisibilityIcon />}
              label="Preview"
              onClick={() => handlePreviewClick(row)}
              color="inherit"
              className="iconMilestone_eye"
            />
          ),
        ];
      },
    },
  ];

  return (
    <>
      <div className="whiteBox">
        <div className="subscriptioncell">

          {/* ✅ Search + Add Record on the same horizontal line — both outside DataGrid */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "16px",
            }}
          >
            <SearchInput
              placeholder="Search Templates"
              value={searchQuery}
              onChange={setSearchQuery}
              className="searchInput"
            />
            {currentPage === 0 && (
              <Button
                className={clsx("btnTheme btnPadding", {
                  "opacity-50 cursor-not-allowed": isAddDisabled,
                })}
                onClick={handleAddClick}
                disabled={isAddDisabled}
              >
                Add template
              </Button>
            )}
          </div>

          <Box
            sx={{
              height: gridHeight,
              boxShadow: "0 1px 2px rgba(0, 0, 0, .06), 0 2px 8px rgba(0, 0, 0, .05)",
              width: "100%",
              "& .actions": { color: "text.secondary" },
              "& .textPrimary": { color: "text.primary" },
              "& .new-row-border": {},
            }}
          >
            <DataGrid
              rows={rows?.map((row: any, index) => ({
                ...row,
                key: row?._id || row.id,
                id: row?._id || row.id,
                templatename: row?.templateName,
                emailContacts: row?.emailContacts,
                emailMilestones: row?.emailMilestones,
                waContacts: row?.waContacts,
                waMilestones: row?.waMilestones,
                whatsappGroups: row?.whatsappGroups,
                whatsappGroupMilestones: row?.whatsappGroupMilestones,
                s_no: index + 1,
                flags: row?.flagDetails || [],
              }))}
              columns={columns}
              loading={loading}
              getRowHeight={() => "auto"}
              getEstimatedRowHeight={() => 52}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              onProcessRowUpdateError={(error) => { }}
              onPaginationModelChange={handlePaginationChange}
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } },
              }}
              pageSizeOptions={[10]}
              slots={{
                toolbar: EditToolbar as GridSlots["toolbar"],
                loadingOverlay: CustomLoadingOverlay,
                noRowsOverlay: CustomNoRowsOverlay,
              }}
              slotProps={{
                loadingOverlay: { message: "Loading templates..." },
                noRowsOverlay: { message: "No templates found" },
              }}
              sx={{
                // Keeps the loading spinner / "No rows" message from collapsing
                // into a tiny sliver when there's no row data to size against.
                "--DataGrid-overlayHeight": "300px",
              }}
              // sx={{
              //   "& .MuiDataGrid-cell": {
              //     display: "flex",
              //     alignItems: "center",
              //     borderBottom: "1px solid rgba(224, 224, 224, 1)",
              //   },
              //   "& .MuiDataGrid-row": {
              //     opacity: "1 !important",
              //     border: "1px solid rgba(224, 224, 224, 1)",
              //     "&:hover": {
              //       border: "1px solid rgba(25, 118, 210, 0.5)",
              //     },
              //     "&.new-row": {
              //       border: "1px solid rgba(76, 175, 80, 0.5)",
              //     },
              //   },
              // }}
            autoHeight={false}
            rowHeight={38}
            columnHeaderHeight={42}
            />
          </Box>
        </div>
      </div>

      {previewOpen && (
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Email & WhatsApp Preview
            <IconButton
              aria-label="close"
              className="iconMilestone_close"
              onClick={() => setPreviewOpen(false)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <Typography variant="h6" gutterBottom>
              📧 Email Preview
            </Typography>
            <Typography
              variant="subtitle1"
              gutterBottom
              sx={{ fontWeight: "bold", color: "text.primary" }}
            >
              {emailPreviewData?.subject || "No Subject"}
            </Typography>
            <div
              dangerouslySetInnerHTML={{ __html: emailPreviewData?.html || "" }}
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "20px",
              }}
            />
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" gutterBottom>
              💬 WhatsApp Preview
            </Typography>
            <pre
              style={{
                background: "#f7f7f7",
                padding: "10px",
                borderRadius: "6px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                fontFamily: "monospace",
              }}
            >
              {whatsappPreviewData || ""}
            </pre>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}